import S from 's-js';
import { DomainSummary } from 'data/models/DomainSummary';
import { UserSummary } from 'data/models/UserSummary';
import { IAjax, Response } from 'lib/Ajax';
import { Login, LoginParams } from 'portcall/login/model';
import { Entrypoints } from 'core/app/entrypoints';

interface AjaxError {
    StatusCode: number;
    ToggleDetails : () => void;
    ShowDetails : () => boolean;
    ServerMessage: string;
    ServerStackTrace : string;
    Remove : () => void;
}
export type AjaxErrors = ReturnType<typeof AjaxErrors>;

export function AjaxErrors(
    domain: DomainSummary,
    ajax : IAjax,
    loginModel : (params : LoginParams) => Login
) {
    let error = S.data<AjaxError | null>(null),
        showLogin = S.data(false),
        login = S(() => showLogin() ? loginModel({ useLandingPage: false, onHidePopup: () => showLogin(false) }) : null);

    S(() => {
        let resp = ajax.LastResponse();
        if (resp) checkResponse(resp);
    });

    return {
        Error: error,
        Login: login,
        SupportHref: supportHref
    };

    function checkResponse(resp : Response<any>) {
        if (resp.Status === 401) { // unauthorized, redirect to login page
            showLogin(true);
        } else if (resp.Status === 500) {
            let showDetails = S.data(false);

            error({
                StatusCode: resp.Status,
                ToggleDetails: function () { showDetails(!showDetails()); },
                ShowDetails: showDetails,
                ServerMessage: resp.Data.Message,
                ServerStackTrace: resp.Data.StackTrace,
                Remove: function () { error(null); }
            });
        }
    }

    function supportHref() : string {
        return 'mailto:' + domain.SupportEmail();
    }
}


// WEBPACK FOOTER //
// ./apps/core/ajaxerrors/model.ts